module.exports = __webpack_public_path__ + "static/services-d2fe1f1722dc98abae85743b85f1a672.png";